var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.866,
    height: 14.748,
    viewBox: "0 0 18.866 14.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-eye",
    transform: "translate(0.433 0.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M14.824,50.5a.592.592,0,0,1-.8-.256h0c-.907-1.768-3.316-4.3-6.455-4.3a7.746,7.746,0,0,0-6.455,4.3.592.592,0,0,1-1.053-.54,8.914,8.914,0,0,1,7.508-4.946c3.794,0,6.511,3,7.508,4.946A.592.592,0,0,1,14.824,50.5Zm-4.344.988a2.906,2.906,0,1,1-2.906-2.911A2.912,2.912,0,0,1,10.479,51.492Zm-1.183,0a1.723,1.723,0,1,0-1.723,1.728A1.727,1.727,0,0,0,9.3,51.492Z",
    transform: "translate(1.48 -40.593)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M.241,43.623l1.318,1.189a.592.592,0,1,0,.793-.879L1.033,42.744a.592.592,0,1,0-.793.879Z",
    transform: "translate(-0.046 -39.181)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M.2,1.031,1.513,2.22a.592.592,0,1,0,.793-.879L.988.152A.592.592,0,1,0,.2,1.031Z",
    transform: "translate(5.079 0) rotate(22)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M2.351,43.623,1.033,44.812a.592.592,0,1,1-.793-.879l1.318-1.189a.592.592,0,0,1,.793.879Z",
    transform: "translate(15.453 -39.181)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M.2,1.341,1.513.152a.592.592,0,1,1,.793.879L.988,2.22A.592.592,0,1,1,.2,1.341Z",
    transform: "translate(13.809 2.199) rotate(158)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open-eye.08b40acf6362b6821a6ff8e7f120b16b.svg";
export { ForwardRef as ReactComponent };